// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1QR62","messages":"Chat_messages__2y5Jz","dateDivider":"Chat_dateDivider__3K9zm"};